module.exports = __webpack_public_path__ + "img/picture_jx500.4136c0c3.png";